import { render, staticRenderFns } from "./add-branch-end.vue?vue&type=template&id=502843da&scoped=true&lang=pug&"
import script from "./add-branch-end.vue?vue&type=script&lang=ts&"
export * from "./add-branch-end.vue?vue&type=script&lang=ts&"
import style0 from "./add-branch-end.vue?vue&type=style&index=0&id=502843da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502843da",
  null
  
)

export default component.exports